import React from "react";
import imagage1 from "../img/The 3th Seal or Encoded Reliquary&&Chants of the Forgotten Interface---Adobe Photoshop interweaving of textured layers over AI-generated and curated images___2025-06[[4]].jpg"
export default function Machine_1_2_6() {
  return (
    <div className="panel-block">
     

      <div className="panel-container-left">
        <img
          loading="lazy"
          src={imagage1}
          alt="1.2.6 · THE INTERMEDIARY PLANE"
        />
      </div>

      <div className="panel-container-right">
         <h2>1.2.6 · THE INTERMEDIARY PLANE</h2>
        <p>Between transmission and reception there is a margin.</p>
    <p>A space where signals distort, where meaning bends.</p>
    <p>Most never notice it.</p>
    <p>Some pass through it by accident.</p>
    <p>Nothing stays there for long.</p>
    <p>Except echoes.</p>
      </div>
    </div>
  );
}
